// Stage des verbundenen Backends, wie STAGE im Dashboard
// (aivy-customer-dashboard/src/helpers/stage.js). Maßgeblich ist aws-exports.js,
// nicht REACT_APP_USER_BRANCH. Ein lokaler Build oder Preview mit
// production-aws-exports ohne Env-Var hieße sonst develop und schriebe ohne
// doppelte Bestätigung auf production.
//
// BUILD_ENV (src/helper/index.js) bleibt für Report-Links und den Lösch-Dialog.

export const STAGES = {
  DEVELOP: 'develop',
  STAGING: 'staging',
  PRODUCTION: 'production'
}

const KNOWN_STAGES = Object.values(STAGES)

/** Stage aus dem S3-Bucket in aws-exports.js oder null */
export const stageFromBackend = (config) => {
  const bucket = config?.aws_user_files_s3_bucket
  return (
    KNOWN_STAGES.find((stage) => bucket === `aivy-user-content-${stage}`) ||
    null
  )
}

/**
 * Stage für Pricing-Flag und Schreibschutz.
 * - aws-exports da, Bucket bekannt: dessen Stage
 * - aws-exports da, Bucket unbekannt: null (unbekannt)
 * - aws-exports fehlt (nur Jest, der Build bricht ohne): die Env-Var, sonst
 *   develop
 */
export const resolveStage = ({ config, buildEnv } = {}) => {
  if (config) return stageFromBackend(config)
  return KNOWN_STAGES.includes(buildEnv) ? buildEnv : STAGES.DEVELOP
}

/**
 * Ob Schreiben auf pricing_enforcement doppelt bestätigt werden muss. Fail
 * closed, eine unbekannte Stage gilt wie production.
 */
export const needsProductionConfirm = (stage) =>
  stage !== STAGES.DEVELOP && stage !== STAGES.STAGING

// Anzeige für Badges und Texte
export const stageLabel = (stage) => stage || 'unbekannte Stage'

const loadAwsExports = () => {
  try {
    // aws-exports.js ist nicht eingecheckt. Der Build braucht die Datei
    // ohnehin (signin.js), Jest läuft auch ohne.
    // eslint-disable-next-line global-require
    return require('../aws-exports').default || null
  } catch {
    return null
  }
}

export const STAGE = resolveStage({
  config: loadAwsExports(),
  buildEnv: process.env.REACT_APP_USER_BRANCH
})
